import React from 'react';

import { Reload } from '../helpers/uiComponents/Reload';
import { addNewMonitor, updateMonitor, getAccountDetails, getMonitorLists } from '../data/serviceUptime';

import { AddMonitor } from './components/MonitorControls';
import AccountStatistics from './components/MonitorStats';
import MonitorSearch from './components/MonitorSearch';
import Monitor from './components/Monitor';
import { hideMessage, showMessage } from '../helpers/uiFunctions/uiActions';

export class UptimeMonitor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lastUpdated: "",
			uptimeMonitors: [],
		}
		this.update = this.update.bind(this);
		this.add = this.add.bind(this);
	}
	componentDidMount() {
		this.loadUptime();
	}
	async loadUptime() {
		await getAccountDetails().then(account => {
			if (this.props.roles.includes('admin')) {
				if (account.down_monitors > 0) {
					showMessage('There are currently '+account.down_monitors+' monitor(s) down...');
				} else {
					hideMessage(true);
				}
			}
			this.setState({
				accountStats: account
			})
		})
		await getMonitorLists(10).then(monitors => {
			this.setState({
				uptimeMonitors: monitors
			})
		})

		var timestamp = Number(new Date());
		timestamp = new Date(timestamp).toLocaleString();
		this.setState({ lastUpdated: timestamp });
	}
	update(id, action) {
		updateMonitor(id, action).then(response => {
			if (response.stat === "ok") {
				this.loadUptime();
			}
		})
	}
	add() {
		var name = document.getElementById('monitor-name');
		var url = document.getElementById('monitor-url');
		document.getElementById("add-monitor-error").innerHTML = "";

		if (url.value && name.value) {
			addNewMonitor(name.value, url.value).then(response => {
				if (response.stat === "ok") {
					document.getElementById("add-monitor-error").innerHTML = "Success! It may take a few minutes for new monitors to show below...";
					this.loadUptime();
					setTimeout(function() {
						name.value = "";
						url.value = "";
						document.getElementById("add-monitor-error").innerHTML = "";
					}, 3000);
				} else {
					document.getElementById("add-monitor-error").innerHTML = "There was an error adding the monitor, please try again";
				}
				
			});
		} else {
			document.getElementById("add-monitor-error").innerHTML = "Please Fill in both the Client Name and the Client Domain before submitting";
		}
	}

	toggleStatus(status) {
		// console.log(status);
		var allMonitors = document.querySelectorAll("#monitors .monitor-row");
		var monitors = document.querySelectorAll("#monitors .monitor-row.status-"+status);
		var tabs = document.querySelectorAll("#monitor-stats .button");

		Object.entries(tabs).forEach(([tabs, tab]) => {
			tab.classList.remove("active");
		});
		document.querySelectorAll("#monitor-stats #tab-"+status)[0].classList.add("active");

		Object.entries(allMonitors).forEach(([monitors, monitor]) => {
			monitor.style.display = "none";
		});
		Object.entries(monitors).forEach(([monitors, monitor]) => {
			monitor.style.display = "inline-block";
		});
	}

	toggleHistory(e) {
		var monitor = e.target.closest("li.monitor-row");
		var history = monitor.querySelector(".history");
		history.classList.toggle("active");
	}

	render() {
		const { lastUpdated, accountStats, uptimeMonitors } = this.state;
		
		return (
			<div style={{"position":"relative"}}>
				<Reload click={() => this.loadUptime()} />
				<section className="section add-monitor">
					<h3>Add Monitors</h3>
					<AddMonitor add={() => this.add()} />
					<AccountStatistics 
						toggleStatus={this.toggleStatus}
						accountStats={accountStats}
						lastUpdated={lastUpdated}
					/>
					<MonitorSearch />
				</section>
				<div id="monitors" className="result-list">
					{(uptimeMonitors.length) && (
						uptimeMonitors.map(monitor => 
							<Monitor
								key={monitor.id}
								monitor={monitor}
								update={this.update}
								toggleHistory={this.toggleHistory}
							/>
						)
					)}
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/component_uptime/Uptime_Monitor.js